import axios from 'axios';
import { Dispatch } from 'redux';
import { ActionType, Action } from '../actionTypes';

export const getSpecs = (productName: string, regionCode: string, apiUrl: string) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.REQUEST_SPEC_DATA
        });

        try {
            const response = await axios.post(apiUrl, {
                productName: productName,
                regionCode: regionCode
            });
            
            //Set all the specs to expanded by default
            response.data.SpecCollections.forEach(c => {
                c.IsExpanded = true;
            });
            
            console.log("ACQUIRING SPEC DAT", response)
            dispatch({
                type: ActionType.RECEIVE_SPEC_DATA,
                payload: response.data
            });
        } catch(err) {
            dispatch({
                type: ActionType.RECEIVE_SPEC_DATA_ERROR,
                payload: err.message
            });
        }
    }
}